<template>
  <div class="form-item">
    <div
      class="form-item-label"
      :class="{ 'form-item-label-focus': labelFocus }"
    >
      手机号
    </div>
    <div class="form-item-content">
      <input
        type="tel"
        @focusin="handleFocusin"
        @focusout="handleFocusout"
        :value="phone"
        @input="handleInput"
      />
      <div>
        <div class="input-line"></div>
        <div
          class="input-focus-line"
          :class="{ 'input-focus-line-active': active }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginInput",
  computed: {
    labelFocus() {
      const phone = this.phone;
      return this.active || (phone !== null && phone.length > 0);
    }
  },
  props: {
    phone: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    handleFocusin() {
      this.active = true;
    },
    handleFocusout() {
      this.active = false;
    },
    handleInput(event) {
      const value = event.target.value.slice(0, 11);
      // 修改state
      this.$emit("update:phone", value);
      // 修改视图
      event.target.value = value;
      if (value.length === 11) {
        this.$emit("validate", true);
      } else {
        this.$emit("validate", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-item {
  position: relative;
  text-align: left;
  width: 100%;
  .form-item-label {
    height: 18px;
    position: relative;
    top: 18px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(200, 202, 216, 1);
    line-height: 50px;
    z-index: 2;
    transition: all 0.4s ease 0s;
  }
  .form-item-label-focus {
    top: 0;
    font-size: 13px;
    line-height: 18px;
    color: rgba(228, 191, 88, 1);
    font-weight: 500;
  }

  .form-item-content {
    position: relative;
    margin-bottom: 41px;
    height: 50px;
    width: 100%;
    input {
      outline: none;
      height: 100%;
      width: 100%;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .input-line {
      position: absolute;
      bottom: -1px;
      width: 100%;
      height: 1px;
      background: rgba(198, 206, 215, 1);
    }
    .input-focus-line {
      position: absolute;
      left: 50%;
      bottom: -1px;
      width: 0;
      height: 2px;
      background: rgba(0, 0, 0, 0.54);
      transition: all 0.4s ease 0s;
    }
    .input-focus-line-active {
      background-color: rgba(228, 191, 88, 1);
      left: 0;
      width: 100%;
    }
  }
}
</style>
